import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './CountersGroup.css';
import React, { useState } from 'react';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
import { ReactComponent as IconMinus } from '../../../resources/icons/icon-minus-round.svg';
import { ReactComponent as IconPlus } from '../../../resources/icons/icon-plus-round.svg';
var Counter = function Counter(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    description = _ref.description,
    title = _ref.title,
    maxLength = _ref.maxLength,
    minLenth = _ref.minLenth,
    setError = _ref.setError,
    infantsError = _ref.infantsError,
    totalError = _ref.totalError,
    infantsCounter = _ref.infantsCounter;
  var counterHandler = function counterHandler(add) {
    if (value >= maxLength && add) {
      setError(infantsCounter ? infantsError : totalError);
      return;
    }
    if (value <= minLenth && !add) return;
    if (onChange) {
      setError('');
      onChange(value + (add ? +1 : -1));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "counter-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-title"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "counter-item__header"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "counter-item__intro"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-btn"
  }, /*#__PURE__*/React.createElement("button", {
    className: "counter-item__btn counter-item__btn--minus ".concat(value === minLenth ? 'counter-item__btn--disabled' : ''),
    onClick: function onClick() {
      counterHandler(false);
    }
  }, /*#__PURE__*/React.createElement(IconMinus, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-value"
  }, value), /*#__PURE__*/React.createElement("div", {
    className: "counter-item__col-btn"
  }, /*#__PURE__*/React.createElement("button", {
    className: "counter-item__btn counter-item__btn--plus ".concat(value === maxLength ? 'counter-item__btn--disabled' : ''),
    onClick: function onClick() {
      counterHandler(true);
    }
  }, /*#__PURE__*/React.createElement(IconPlus, {
    className: "icon"
  }))));
};
var CountersGroup = function CountersGroup(_ref2) {
  var adults = _ref2.adults,
    setAdults = _ref2.setAdults,
    childrens = _ref2.childrens,
    setChildrens = _ref2.setChildrens,
    infants = _ref2.infants,
    setInfants = _ref2.setInfants,
    title = _ref2.title,
    intro = _ref2.intro,
    textAdults = _ref2.textAdults,
    descriptionAdult = _ref2.descriptionAdult,
    textChildren = _ref2.textChildren,
    descriptionChildren = _ref2.descriptionChildren,
    textInfants = _ref2.textInfants,
    descriptionInfants = _ref2.descriptionInfants,
    textCabinClass = _ref2.textCabinClass,
    textEconomy = _ref2.textEconomy,
    textBusiness = _ref2.textBusiness,
    textAmountValidationInfants = _ref2.textAmountValidationInfants,
    textAmountValidationTotal = _ref2.textAmountValidationTotal,
    economyCabinClass = _ref2.economyCabinClass,
    setEconomyCabinClass = _ref2.setEconomyCabinClass,
    textClear = _ref2.textClear,
    textSave = _ref2.textSave,
    rtl = _ref2.rtl,
    close = _ref2.close,
    saveAction = _ref2.saveAction;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-close d-none d-md-block",
    onClick: function onClick() {
      close();
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: function onClick() {
      close();
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, title), !(adults === 1 && childrens === 0 && infants === 0 && economyCabinClass) && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: function onClick() {
      setAdults(1);
      setChildrens(0);
      setInfants(0);
      setEconomyCabinClass(true);
      setError('');
    }
  }, textClear)), /*#__PURE__*/React.createElement("div", {
    className: "counters-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counters-items"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "d-none d-md-block counters-items__header"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "counters-items__intro"
  }, intro), /*#__PURE__*/React.createElement(Counter, {
    onChange: setAdults,
    value: adults,
    description: descriptionAdult,
    title: textAdults,
    maxLength: 9 - childrens,
    minLenth: 1,
    setError: setError,
    infantsError: textAmountValidationInfants,
    totalError: textAmountValidationTotal
  }), /*#__PURE__*/React.createElement(Counter, {
    onChange: setChildrens,
    value: childrens,
    description: descriptionChildren,
    title: textChildren,
    maxLength: 9 - adults,
    minLenth: 0,
    setError: setError,
    infantsError: textAmountValidationInfants,
    totalError: textAmountValidationTotal
  }), /*#__PURE__*/React.createElement(Counter, {
    onChange: setInfants,
    value: infants,
    description: descriptionInfants,
    title: textInfants,
    maxLength: adults,
    minLenth: 0,
    setError: setError,
    infantsError: textAmountValidationInfants,
    totalError: textAmountValidationTotal,
    infantsCounter: true
  })), error ? /*#__PURE__*/React.createElement("div", {
    className: "counters-error-message-wrapper"
  }, error) : null, /*#__PURE__*/React.createElement("div", {
    className: "counters-class-selector"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "counters-class-selector__header"
  }, textCabinClass), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "radiobutton-item"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "class-type-economy",
    name: "class-type",
    checked: economyCabinClass,
    onChange: function onChange() {
      setEconomyCabinClass(true);
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "radiobutton-item__label",
    htmlFor: "class-type-economy"
  }, /*#__PURE__*/React.createElement("span", {
    className: "radiobutton-item__label-text"
  }, textEconomy))), /*#__PURE__*/React.createElement("div", {
    className: "radiobutton-item"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: "class-type-business",
    name: "class-type",
    checked: !economyCabinClass,
    onChange: function onChange() {
      setEconomyCabinClass(false);
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "radiobutton-item__label",
    htmlFor: "class-type-business"
  }, /*#__PURE__*/React.createElement("span", {
    className: "radiobutton-item__label-text"
  }, textBusiness)))))), /*#__PURE__*/React.createElement("div", {
    className: "counters-footer d-md-none"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      close();
      saveAction();
    }
  }, textSave)));
};
var commonStyles = "c2tb7xx";
var ltrStyles = "ls0jwjp";
var rtlStyles = "r1712nah";
var StyledWrapper = function StyledWrapper(_ref3) {
  var rtl = _ref3.rtl,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "\n  amount-dropdown\n  ".concat(commonStyles, "\n  ").concat(rtl ? rtlStyles : ltrStyles, "\n")
  }, children);
};
export default CountersGroup;